import gsap from 'gsap';
import each from 'lodash/each';

export default class CarouselInfiniteAutoplay {
    constructor() {
        this.carousel = document.querySelector('[data-carousel="infinite-autoplay"]')

        this.createCarousel(this.carousel);
    }

    createCarousel(target) {
        var slides = target.querySelectorAll('.slide');
        //   console.log(this.slider.container)
        console.log(slides)
        console.log(target.clientWidth)
        // //initially colorize each box and position in a row

        // gsap.set(this.slider.slides, {
        //   x: (index) => index * this.slider.slides[0].clientWidth,
        // });


        // gsap.to(this.slider.slides, {
        //   duration: 5,
        //   ease: "none",
        //   x: "+="+this.slider.slides[0].clientWidth, //move each box 500px to right
        //   modifiers: {
        //     x: gsap.utils.unitize(gsap.utils.wrap(0, window.innerWidth), "px")
        //   },
        //   repeat: -1
        // });

        this.totalWidth = (slides[0].clientWidth * slides.length);
        console.log(this.totalWidth)

        //initially colorize each box and position in a row
        gsap.set(slides, {
            x: (i) => i * slides[0].clientWidth,
        });


        gsap.to(slides, {
            duration: 35,
            ease: "none",
            x: "+=" + this.totalWidth, //move each box 500px to right
            modifiers: {
                x: gsap.utils.unitize(x => parseFloat(x) % this.totalWidth) //force x value to be between 0 and 500 using modulus
            },
            repeat: -1
        });
    }
}